export const PERSONALIZADO = 'P'
export const GENERAL = 'G'
